export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
          联系我们
        </h2>
        <p className="text-foreground-500 text-base mb-8 max-w-lg mx-auto">
          欢迎投稿爆料或商务合作，我们期待你的声音
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-200">
            <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-send-line text-xl text-primary-500"></i>
            </div>
            <h3 className="text-base font-heading text-foreground-900 mb-2">投稿爆料</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              提供新鲜瓜料和独家线索
            </p>
            <p className="text-xs text-primary-500 mt-3 font-medium">tougao@51chigua.com</p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-accent-200 transition-all duration-200">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-briefcase-line text-xl text-accent-500"></i>
            </div>
            <h3 className="text-base font-heading text-foreground-900 mb-2">商务合作</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              品牌推广与广告投放咨询
            </p>
            <p className="text-xs text-accent-500 mt-3 font-medium">hezuo@51chigua.com</p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-secondary-200 transition-all duration-200">
            <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-line text-xl text-secondary-500"></i>
            </div>
            <h3 className="text-base font-heading text-foreground-900 mb-2">用户反馈</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              意见与建议帮助我们做得更好
            </p>
            <p className="text-xs text-secondary-500 mt-3 font-medium">fankui@51chigua.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}